var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-section uk-section-muted uk-flex uk-flex-middle uk-animation-fade",attrs:{"uk-height-viewport":""}},[_c('div',{staticClass:"uk-width-1-1"},[_c('div',{staticClass:"uk-container"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }